import React from 'react';

import CommonModal from 'jbc-front/components/CommonModal';
import Button from 'jbc-front/components/Button';
import { ErrorsSection, LoadingWithDescription } from 'src/components';

import { FormSubmitBtn } from 'src/buttons';
import styles from './ConfirmRevisionModal.scss';

const applyYm = yearMonth => `${yearMonth.split('_')[0]}年9月`;
const paymentYm = yearMonth => `${yearMonth.split('_')[0]}年10月`;

class ConfirmRevisionModal extends React.Component {
  render() {
    const header = '標準報酬月額改定';
    const { revisions, isOpen, hideModal, yearMonth, handleSubmit, submitting, submit, errors } = this.props;

    return (
      <CommonModal ariaHideApp={false} {...{ isOpen, hideModal, yearMonth }}>
        <CommonModal.Header hideModal={hideModal}>{header}</CommonModal.Header>
        <CommonModal.Body>
          <form onSubmit={handleSubmit}>
            <ErrorsSection errors={errors} />
            {submitting && <LoadingWithDescription text="確定中です。少々お待ちください。" />}
            <div>
              <table className="m-table-item">
                <thead>
                  <tr>
                    <th>スタッフコード</th>
                    <th>氏名</th>
                    <th>現在</th>
                    <th>{applyYm(yearMonth)}〜</th>
                  </tr>
                </thead>
                <tbody>
                  {revisions &&
                    revisions.map(revision => (
                      <tr key={`revision_tr_${revision.id}`}>
                        <td>{revision.staffCode}</td>
                        <td>{`${revision.lastName} ${revision.firstName}`}</td>
                        <td>{revision.beforeMonthlyCompensationHealthInsuranceAmount}</td>
                        <td>{revision.afterMonthlyCompensationHealthInsuranceAmount}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <ul className={styles.notes}>
              <li>
                ※ {applyYm(yearMonth)}分（{paymentYm(yearMonth)}支給分）以降の標準報酬月額が、上記のように改定されます。<br />本当によろしいですか？
              </li>
            </ul>
          </form>
        </CommonModal.Body>
        <CommonModal.Footer>
          <Button onClick={hideModal} className="u-mr20">
            キャンセル
          </Button>
          <FormSubmitBtn text="確定" {...{ submitting, submit }} />
        </CommonModal.Footer>
      </CommonModal>
    );
  }
}

export default ConfirmRevisionModal;
